<template>
  <div>
    <header>
      <a href="https://www.magazine.co.uk" title="Go to magazine.co.uk"
        ><img class="logo" src="./assets/logo.png"
      /></a>
    </header>
    <router-view />
  </div>
</template>

<!-- Comment -->

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@600;700;800&display=swap");

$main-button-color: #e20c0b;

body {
  font-family: "Open Sans", sans-serif;
  margin: 0;
  background: #222;
  color: #fff;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  font-size: 16px;
}

header {
  width: 100%;
  min-height: 50px;
  padding: 0;
  background-color: #333;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #fff;

  img.logo {
    height: 21px;
  }
}

h1 {
  text-align: center;
  font-size: 20px;
  font-weight: 800;
  margin: 20px 0 20px 0;

  span {
    display: block;
    font-size: 16px;
    font-weight: 700;
  }
}

hr {
  width: 100%;
  max-width: 600px;
}

.content-light {
  display: flex;
  flex-direction: column;

  h1 {
    text-align: left;
  }
}

h2 {
  text-align: center;
  font-size: 16px;
  font-weight: 800;
  margin: 0 0 20px 0;
}

.subtitle {
  font-size: 16px;
  font-weight: 800;
  text-align: center;
}

.contentwrapper {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 50px);
}

.content-dark {
  // min-height: calc(100vh - 50px);
  display: flex;
  flex-direction: column;
  // max-width: 500px;

  a {
    color: #fff;
  }
}

.content-light {
  background: #eee;
  color: #222;
  text-align: left;
  padding: 5px 20px 40px 20px;
}

.more-arrow {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  flex-grow: 1;
  padding-bottom: 20px;
  img {
    width: auto;
  }
}

.button-second {
  font-size: 14px;
  line-height: 28px;
  // color: #fff;
  background: #aaa;
  font-weight: 500;
  text-decoration: none;
  margin: 0 10px;
  padding: 5px;
  border-radius: 5px;
  border: 2px solid #888;

  &:hover {
    background: #ccc;
  }
}

.button-default,
.button-unselected,
.button-disabled {
  font-size: 16px;
  line-height: 28px;
  color: #fff;
  font-weight: 700;
  min-width: 150px;

  margin: 0 10px;
}

.button-default {
  background: $main-button-color;
  border: 2px solid #fff;
  border-radius: 5px;
  padding: 5px;
}

.tracker-navigation {
  text-align: center;

  .button-unselected,
  .button-disabled {
    background: none;
    border: none;
    border-bottom: 1px solid #fff;
  }

  .button-disabled {
    border-bottom: 1px solid #444;
    color: #444;
  }
}

.faq {
  padding: 0px;

  li {
    list-style: none;
    font-weight: 700;
    margin-bottom: 20px;
    text-align: left;
    line-height: 20px;
    font-size: 16px;
  }
}

.button-back {
  font-size: 14px;
  font-weight: 700;
  background: none;
  border: none;
  color: #fff;
  margin-left: 10px;
  margin-top: 10px;
  text-align: left;
  display: inline-block;
  align-self: flex-start;
}

a,
button {
  cursor: pointer;
}

a {
  text-decoration: underline;
}

.overlay-wrapper {
  position: fixed; /* Sit on top of the page content */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7); /* Black background with opacity */
  z-index: 200; /* Specify a stack order in case you're using a different order for other elements */
  display: flex;
  justify-content: center;
  align-items: center;

  .dialog {
    color: #000;
    text-align: left;
    display: flex;
    flex-direction: column;
    background: #fff;
    min-width: 200px;
    max-width: 600px;
    border-radius: 10px;
    margin: 50px 30px;
    padding: 15px;
    max-height: 90vh;
    overflow-y: auto;

    .questions {
      margin: 0 20px 20px 20px;
    }

    h3 {
      margin-top: 10px;
    }

    p {
      line-height: 26px;
    }
    button {
      background: none;
      border: none;
      color: #000;
      font-size: 20px;
      align-self: flex-end;
    }

    a {
      cursor: pointer;
      text-decoration: underline;
      font-weight: 700;
      color: #222;
    }
  }
}

//*bigger screens*

@media (min-device-width: 768px) {
  /* For general tablets/desktops*/
  .contentwrapper {
    flex-direction: row;
    justify-content: center;

    .content-dark,
    .content-light {
      flex-grow: 1;
      flex-shrink: 1;
      flex-basis: 100%;
    }

    .content-dark {
      align-items: center;
    }
  }

  .more-arrow {
    display: none;
  }

  .nw {
    white-space: nowrap;
  }
}
</style>
